import { render, staticRenderFns } from "./AMapTest.vue?vue&type=template&id=0826b08a&scoped=true&"
import script from "./AMapTest.vue?vue&type=script&lang=js&"
export * from "./AMapTest.vue?vue&type=script&lang=js&"
import style0 from "./AMapTest.vue?vue&type=style&index=0&id=0826b08a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826b08a",
  null
  
)

export default component.exports